import React, { useState, useEffect } from 'react';
import api from '../config/api';

const Gallery = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get('/gallery/public')
      .then(res => setPhotos(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // Use villa images as default gallery
  const defaultImages = [
    "https://royalgardenvillas.in/images/3bhk/1.webp",
    "https://royalgardenvillas.in/images/4bhk/2.webp",
    "https://royalgardenvillas.in/images/5bhk/1.webp",
    "https://royalgardenvillas.in/images/3bhk/7.webp",
    "https://royalgardenvillas.in/images/4bhk/9.webp",
    "https://royalgardenvillas.in/images/5bhk/7.webp",
    "https://royalgardenvillas.in/images/3bhk/17.webp",
    "https://royalgardenvillas.in/images/4bhk/21.webp",
    "https://royalgardenvillas.in/images/5bhk/14.webp",
  ];

  const displayImages = photos.length > 0 ? photos.map(p => p.image_url) : defaultImages;

  return (
    <div data-testid="gallery-page" className="pt-20">
      <section className="py-16 md:py-24 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="label-uppercase mb-4">Memories</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light" style={{ fontFamily: "'Playfair Display', serif" }}>
            Photo <span className="text-[#F57C20]">Gallery</span>
          </h1>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {loading ? (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {[1,2,3,4,5,6].map(i => <div key={i} className="shimmer aspect-square" />)}
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {displayImages.map((img, i) => (
                <div key={i} className="aspect-square overflow-hidden img-hover-scale">
                  <img src={img} alt={`Gallery ${i+1}`} className="w-full h-full object-cover" />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Gallery;
